// Patna city imagery + Hindi flavor
// Full-viewport backgrounds — real Patna city photos from Wikimedia Commons
const wm = (name, width = 1920) =>
  `https://commons.wikimedia.org/wiki/Special:FilePath/${name}?width=${width}`;

export const PATNA_BACKGROUNDS = [
  {
    url: wm('River_Ganges_with_Gandhi_Bridge_and_parts_of_Patna_skyline.jpg'),
    caption: 'Gandhi Setu over the Ganga',
    hi: 'गंगा पर गांधी सेतु',
  },
  {
    url: wm('River_Ganga_in_Patna_201_(1).JPG'),
    caption: 'The Ganga at Patna',
    hi: 'पटना में गंगा',
  },
  {
    url: wm('Golghar,_Patna,_Bihar.jpg'),
    caption: 'Golghar — Where echoes live',
    hi: 'गोलघर',
  },
  {
    url: wm('Patna_Sahib_Gurudwara.jpg'),
    caption: 'Takht Sri Patna Sahib',
    hi: 'तख्त श्री पटना साहिब',
  },
  {
    url: wm('Patna_river_port1.JPG'),
    caption: 'Gai Ghat, Patna river port',
    hi: 'गाय घाट, पटना',
  },
];

export const PATNA_QUOTES = [
  { hi: 'गंगा किनारे बसा है, गीतों का घराना', en: 'By the Ganga\'s edge lives a home of melodies' },
  { hi: 'पटना की गलियाँ, बॉलीवुड की धुनें', en: 'Patna\'s alleys, Bollywood\'s tunes' },
  { hi: 'जहाँ हर मोड़ पर एक गाना है', en: 'Where every turn hides a song' },
  { hi: 'चाय पीके, गाना सुनो', en: 'Sip a chai, hear a tune' },
  { hi: 'बिहार का बीट, बॉलीवुड का जज़्बा', en: 'Bihar\'s beat, Bollywood\'s soul' },
  { hi: 'गोलघर से गीतों तक', en: 'From Golghar to gramophones' },
];

export const HINDI_STRINGS = {
  welcomeBack: 'फिर मुलाकात',
  byEra: 'दौर के हिसाब से',
  byMood: 'मूड के हिसाब से',
  nowPlaying: 'अभी बज रहा है',
  upNext: 'अगला गीत',
  enterStudio: 'अंदर आइए',
  listenAndSway: 'सुनिए और झूमिए',
  admin: 'प्रबंधक',
  search: 'खोज',
  brand: 'पटना के प्रेस्ली',
  trending: 'पटना में धूम',
};

// Convenience export retained for backwards compat during migration
export const PATNA_IMAGES = {
  golghar: wm('Golghar,_Patna,_Bihar.jpg'),
  patnaSahib: wm('Patna_Sahib_Gurudwara.jpg'),
  skyline: wm('River_Ganges_with_Gandhi_Bridge_and_parts_of_Patna_skyline.jpg'),
  ganga: wm('River_Ganga_in_Patna_201_(1).JPG'),
  ghat: wm('Patna_river_port1.JPG'),
};
